import React, { Component } from 'react'
import { connect } from 'react-redux'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'

import {
	showHideModalCreateOtrosi
} from '../../actions/common'


import {
	createOtrosi
} from '../../actions/otrosi'



class ModalCreate extends Component {

	handleCloseModal = (e) => {

		const modal = document.getElementById('modalCreateOtrosi')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalCreateOtrosi .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.showHideModalCreateOtrosi(false), 300)

	}

	render() {
		const { modalCreateOtrosi } = this.props
		if (!modalCreateOtrosi.get('show')) {
			return null
		}
		return(
			<Modal id="modalCreateOtrosi" show={ true } ZIndex={ 2000 } >
				<ModalHeader title="Confirmación" onClose={ (e) => this.handleCloseModal(e) } />
				<ModalBody>
					<div style={{ width: '400px' }}>
						<div className="row">
							<div className="col-md-12" style={{ color: '#000', fontWeight: '300' }}>								
								{ modalCreateOtrosi.get('message') }
							</div>
						</div>
					</div>
				</ModalBody>
				<ModalFooter>
					<button className="btn btn-default" type="button" onClick={ (e) => this.props.createOtrosi() }>OTROSI</button>
					<button className="btn btn-default" type="button" onClick={ (e) => this.handleCloseModal() }>Cancelar</button>
				</ModalFooter>
			</Modal>
		)
	}
}

const mapStateToProps = (state, onwProps) => {
	return {
		modalCreateOtrosi: state.common.get('modalCreateOtrosi')
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		showHideModalCreateOtrosi: (open) => dispatch(showHideModalCreateOtrosi(open)),
		createOtrosi: () => dispatch(createOtrosi())
		
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreate)



// WEBPACK FOOTER //
// ./src/components/Otrosi/ModalCreate.jsx